export const LIUBA_LOCAL_LESSON_VENUES = [
  {
    venue_id: "ely_studio",
    venue_slug: "ely",
    public_name: "Ely Studio",
    venue_name: null,
    address_lines: ["17 Avocet Grove", "Soham", "Ely", "Cambridgeshire"],
    postcode: "CB7 5GN",
    area_label: "Ely / Soham",
    nearby_areas: "near Ely and Soham",
    short_description:
      "Liuba Doga's local teaching location near Ely and Soham for in-person Singing Attitude Method based lessons.",
  },
  {
    venue_id: "bury_st_edmunds_studio",
    venue_slug: "bury-st-edmunds",
    public_name: "Bury St Edmunds Studio",
    venue_name: "The Rehearsal Rooms",
    address_lines: ["4 St Andrews Street South", "Bury St Edmunds"],
    postcode: "IP33 3PH",
    area_label: "Bury St Edmunds",
    nearby_areas: "in Bury St Edmunds",
    short_description:
      "Liuba Doga's Bury St Edmunds teaching location at The Rehearsal Rooms for local in-person singing lessons.",
  },
] as const;

export type LiubaLocalLessonVenue = (typeof LIUBA_LOCAL_LESSON_VENUES)[number];
export type LiubaLocalLessonVenueId = LiubaLocalLessonVenue["venue_id"];

export function isLiubaLocalLessonVenueId(value: string): value is LiubaLocalLessonVenueId {
  return LIUBA_LOCAL_LESSON_VENUES.some((venue) => venue.venue_id === value);
}

export function getLiubaLocalLessonVenue(venueId: LiubaLocalLessonVenueId) {
  return LIUBA_LOCAL_LESSON_VENUES.find((venue) => venue.venue_id === venueId) ?? null;
}

export function getLiubaLocalLessonVenueBySlug(venueSlug: LiubaLocalLessonVenue["venue_slug"]) {
  return LIUBA_LOCAL_LESSON_VENUES.find((venue) => venue.venue_slug === venueSlug) ?? null;
}

export function formatLiubaVenueAddress(venue: LiubaLocalLessonVenue) {
  return [...venue.address_lines, venue.postcode].join(", ");
}

export function getLiubaVenueDisplayName(venue: LiubaLocalLessonVenue) {
  return venue.venue_name ? `${venue.public_name} (${venue.venue_name})` : venue.public_name;
}

export function getLiubaVenueSearchUrl(venue: LiubaLocalLessonVenue) {
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(formatLiubaVenueAddress(venue))}`;
}
